/** Lightweight pub/sub so assistant/MCP actions can trigger view methods. */

const listeners = new Map();

export function onCommand(type, handler) {
  if (!listeners.has(type)) listeners.set(type, new Set());
  listeners.get(type).add(handler);
  return () => listeners.get(type)?.delete(handler);
}

export function emitCommand(type, payload) {
  const set = listeners.get(type);
  if (!set) return 0;
  for (const handler of set) {
    try {
      handler(payload);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(`command ${type} failed`, err);
    }
  }
  return set.size;
}
